import React from 'react';

const NotFound = () => {
    return (
        <div>

            <img src="https://colorlib.com/wp/wp-content/uploads/sites/2/404-error-page-templates.jpg" alt="" srcset="" />
            <br />
            <button className="btn btn-danger mb-5"> Go Home</button>
        </div>
    );
};

export default NotFound;